import React from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  FormControlLabel,
  FormControl,
  RadioGroup,
  Typography,
  TextField,
  Radio,
  Button,
} from "@material-ui/core";

const styles = () => ({
  fieldTypeRadio: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "nowrap",
  },
  upperBtn: {
    marginBottom: 10,
  },
  formControlLabel: {
    marginRight: 5
  }
});

const ValueField = ({
  onChangeValue,
  classes,
  addNestedField,
  currentNode,
  parentName,
}) => {
  const { type, value } = currentNode
  if (type.value === "number") {
    return (
      <TextField
        fullWidth
        required
        variant="outlined"
        label="Value"
        type="number"
        value={value.value}
        onChange={(e) => onChangeValue({ newValue: e.target.value }) }
      />
    );
  } else if (type.value === "boolean") {
    return (
      <FormControl component="fieldset">
        <RadioGroup
          value={value.value}
          onChange={(e) => onChangeValue({ newValue: e.target.value === "true" }) }
          className={classes.fieldTypeRadio}
        >
          <FormControlLabel
            className={classes.formControlLabel}
            value={true}
            control={<Radio />}
            label="True"
          />
          <FormControlLabel value={false} control={<Radio />} label="False" />
        </RadioGroup>
      </FormControl>
    );
  } else if (type.value === "object") {
    return (
      <Button
        className={classes.upperBtn}
        variant="contained"
        color="primary"
        onClick={() => addNestedField(currentNode.id)}
      >
        <Typography noWrap>Add field - [{parentName}]</Typography>
      </Button>
    );
  } else {
    return (
      <TextField
        fullWidth
        required
        variant="outlined"
        label="Value"
        value={`${value.value}`}
        onChange={(e) => onChangeValue({ newValue: e.target.value }) }
      />
    );
  }
};

export default withStyles(styles)(ValueField);
